<template>
    <div>
        <v-card-title class="">门店促销编辑</v-card-title>
        <v-card-text v-if="form">
            <v-row>
                <v-col cols="6">
                    <v-text-field label="名称*" name="name" dense placeholder="" v-model="form.name" data-vv-name="name"
                        :error-messages="errors.name" required :hide-details="false"></v-text-field>
                </v-col>
            </v-row>
            <v-row class="my-0">
                <v-col cols="12" sm="9">
                    <v-radio-group v-model="form.status" label="状态" row :error-messages="errors.status">
                        <v-radio v-for="(l, k) in refs['STATUSLABEL']" :value="l.value" :label="l.text"
                            :key="k"></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col cols="12" sm="3">
                    背景色(方便区分)
                    <color-picker v-model="form.color"></color-picker>
                </v-col>
                <v-col cols="12" class="align-center d-flex flex-row">
                    <v-radio-group v-model="form.type" label="类型" row :error-messages="errors.type">
                        <v-radio v-for="(l, k) in refs['TYPELABEL']" :value="l.value" :label="l.text"
                            :key="k"></v-radio>
                    </v-radio-group>
                    <v-text-field style="max-width: 10rem" v-model="form.value" type=number
                        :error-messages="errors.value" hint="折扣值，抵扣金额" persistent-hint>
                        <template #append>
                            <template v-if="form.type === 'discount'">折</template>
                            <template v-if="form.type === 'markdown'">元</template>
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="6" class="align-center d-flex flex-row">
                    <v-datetime-picker label="开始时间" :datetime="form.starttime"
                        @input="onDatetimeSelected('starttime', $event)" :textFieldProps="{
                            class: 'd-inline-block mr-2',
                            clearable: true,
                            hideDetails: true,
                            errorMessages: errors.starttime
                                ? errors.starttime
                                : null
                        }" class="d-inline"></v-datetime-picker>
                </v-col>
                <v-col cols="12" sm="6" class="align-center d-flex flex-row">
                    <v-datetime-picker label="结束时间" :datetime="form.endtime"
                        @input="onDatetimeSelected('endtime', $event)" :textFieldProps="{
                            class: 'd-inline-block mr-2',
                            clearable: true,
                            hideDetails: true,
                            errorMessages: errors.endtime
                                ? errors.endtime
                                : null
                        }" class="d-inline"></v-datetime-picker>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" class="d-flex flex-row align-center">
                    <v-radio-group v-model="form.cycle" label="使用周期" row :error-messages="errors.cycle"
                        stylexx="width:30rem">
                        <v-radio v-for="(l, k) in refs['CYCLELABEL']" :value="l.value" :label="l.text"
                            :key="k"></v-radio>
                    </v-radio-group>
                    <v-text-field label="周期总限量" v-model="form.qtyPerCycle" :error-messages="errors.qtyPerCycle"
                        style="width:5rem" class="mr-2" type="number" hint0="如果是作用范围是「订单」则是总的次数，如果是商品或SKU，则是商品的售出数量限制"
                        persistent-hint></v-text-field>
                    <v-text-field label="周期每人限量" v-model="form.qtyPerUserCycle" :error-messages="errors.qtyPerUserCycle"
                        style="width:5rem" type="number" hint="默认为1，不可超过「周期总限量」" persistent-hint></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" class="d-flex flex-row align-center">
                    <v-radio-group label="作用范围" v-model="form.base" :error-messages="errors.base" row disabled>
                        <v-radio :key="k" v-for="(l, k) in refs['BASELABEL']" :label="l.text"
                            :value="l.value"></v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>

            <v-textarea outlined rows="2" v-model="form.description" label="备注" hide-details />
        </v-card-text>
        <v-card-actions>
            <slot name="actions" v-bind:object="form"></slot>
        </v-card-actions>
    </div>
</template>

<script>
import { clone } from 'lodash-es'
import { format } from 'date-fns'
import RichEditor from '../tools/RichEditor.vue'
import ColorPicker from '../common/ColorPicker.vue'
/**
 * 门店端编辑促销
 */
export default {
    components: { RichEditor, ColorPicker },
    props: {
        value: { type: Object, default: null },
        errors: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data: () => ({
        form: null,
        refs: {},
        shops: [],
        showColorPicker: false,
        tempColor: null
    }),
    computed: {
        shopIds() {
            return this.shops.map((e) => e.id)
        }
    },
    watch: {
    },
    mounted() {
        this.form = clone(this.value)
        this.form.base = 'order' //默认为订单并且不能修改
        this.$api.common.getMeta(
            'Sale',
            'CYCLELABEL,STATUSLABEL,SUPPORTEDORDERLABEL,TYPELABEL,BASELABEL',
            (r) => {
                this.refs = r
            }
        )
    },
    methods: {
        loadShops(ids) {
            let idstr = ids.join(',')
            this.$api.shop.getByIds(`${idstr}`, (r) => (this.shops = r))
        },

        onColorPicked(c) {
            if (typeof c === 'object') {
                this.form.color = c.hexa
            } else {
                this.form.color = c
            }
        },
        confirmColor() {
            this.onColorPicked(this.tempColor)
            this.showColorPicker = false
        },
        onCategorySelected(ids) {
            this.form.category_id = ids[0]
        },
        clear() {
            this.form = {}
        },
        onImgUploaded(files) {
            this.form.imgurl = files[0]
        },
        onEditorChanged(html) {
            this.form.description = html
        },
        onShopSelected(ids, objs) {
            if (!ids || ids.length === 0) this.form.shopIds = null
            else this.form.shopIds = ids
        },
        onDatetimeSelected(f, dt) {
            this.form[f] = format(dt, 'yyyy-MM-dd HH:mm')
        }
    }
}
</script>
